import styled from 'styled-components'

import { AppFull } from '../../../../AppStyle';

const AlarmsContent = styled(AppFull)`
  overflow: auto;
`

export {AlarmsContent}
